import type { HyperElement, HyperElements, PaymentFlowCancelEvent } from '@appercut/round-vue';
import { FLOW_CANCEL_EVENT, readFlowCancel } from '@appercut/round-vue';
import {
  HYPERSWITCH_WALLET_BUTTON_HEIGHT,
  HYPERSWITCH_WALLET_MOUNT_ID,
} from '../common/constants/hyperswitchAppearance';

interface WalletButtonOptions {
  wallets: () => Record<string, unknown>;
  onComplete: () => void;
  onClick?: () => void;
  onCancel?: (event: PaymentFlowCancelEvent) => void;
}

export function useHyperswitchWalletButton(options: WalletButtonOptions) {
  let element: HyperElement | null = null;

  function destroy(): void {
    element?.destroy();
    element = null;
  }

  function mountFrom(elements: HyperElements | null | undefined): void {
    destroy();
    if (!elements || !document.getElementById(HYPERSWITCH_WALLET_MOUNT_ID)) return;

    const wallets = options.wallets();
    const created = elements.create('expressCheckout', {
      wallets: { ...wallets, style: { height: HYPERSWITCH_WALLET_BUTTON_HEIGHT } },
      subscriptionEvents: [FLOW_CANCEL_EVENT],
    });
    created.on('change', (payload) => {
      const cancelled = readFlowCancel(payload);

      if (cancelled) options.onCancel?.(cancelled);
    });
    created.onSDKHandleClick(async () => {
      options.onClick?.();
    });
    created.on('completeDoThis', options.onComplete);
    created.mount(`#${HYPERSWITCH_WALLET_MOUNT_ID}`);
    element = created;
  }

  onBeforeUnmount(destroy);

  return { mountFrom, destroy };
}
